'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _Card = require('./Card.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
* Basic Card component.
*/
var Card = exports.Card = function Card(_ref) {
  var children = _ref.children,
      className = _ref.className,
      onClick = _ref.onClick;
  return _react2.default.createElement(
    'div',
    {
      className: className + ' card',
      onClick: onClick },
    children
  );
};

Card.propTypes = {
  /**
   * The children to be rendered inside a card. If child is a Card,
   * it will have no border.
   */
  children: _propTypes2.default.node,
  /**
   * glamorous className
   */
  className: _propTypes2.default.string.isRequired,
  /**
   * onClick function passed to whole card
   */
  onClick: _propTypes2.default.func
};

exports.default = (0, _glamorous2.default)(Card)(_Card.defaultStyle, _Card.mapPropsAndThemeToStyle);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/cards/Card/Card.js
// module id = 447
// module chunks = 0